let observer = createObserver();

function createObserver() {
	const options = {
		root: null,
		rootMargin: '0px',
		scrollMargin: '0px',
		threshold: 0.15,
	};
	const observer = new IntersectionObserver(onIntersect, options);

	function onIntersect(entries, _observer) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				addAnimation(entry.target);
			}
		});
	}

	let animations = document.querySelectorAll('[data-animation]');

	animations.forEach((animation) => {
		observer.observe(animation);
	});

	return observer;
}

document.addEventListener('facetwp-loaded', function () {
	observer.disconnect();
	observer = createObserver();
});

document.addEventListener('facetwp-refresh', function () {
	observer.disconnect();
	observer = createObserver();
});

function addAnimation(element) {
	let animation = element.getAttribute('data-animation');
	let delay = element.getAttribute('data-delay');
	element.classList.add(animation);
	if (delay != undefined) {
		element.style.animationDelay = delay + 'ms';
	} else {
		element.style.animationDelay = '0.15s';
	}
}

function isScrolledIntoView(elem) {
	const docViewTop = window.scrollY;
	const docViewBottom = docViewTop + (window.innerHeight + 500); // 400px offset for earlier response

	const elemTop = elem.getBoundingClientRect().top + docViewTop;
	const elemBottom = elemTop + window.innerHeight * 0.6;

	return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

function removeAnimation(element) {
	let animation = element.data('animation');
	element.removeClass(animation);
}
